<template>
  <div id="app">
<!--    <login/>-->
<!--    <ECharts/>-->
<!--    <Menu/>-->
<!--    <Card/>-->
    <router-view></router-view>
  </div>
</template>

<script>
import login from "./views/Login.vue";
import Menu from "./views/Menu.vue";
import ECharts from "./components/ECharts.vue";
import Card from "./components/Card.vue";
export default {
  name: 'App',
  components: {
    login,
    Menu,
    ECharts,
    Card
  },
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue